function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 28"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22 11.5v3a1.5 1.5 0 01-1.5 1.5h-19A1.5 1.5 0 010 14.5v-3A1.5 1.5 0 011.5 10h19a1.5 1.5 0 011.5 1.5z"
})));